import React, { FunctionComponent } from "react";
import { Flex } from "@chakra-ui/react"

import { useGlobalState } from "common/global-state";
import Navbar from "./Navbar";

const Layout: FunctionComponent<{}> = ({ children }) => {
  const { connected } = useGlobalState();

  return (
    <Flex flexDirection={"column"} flexGrow={1} filter={connected ? "initial" : "grayscale(100%)"} transition="filter 1s ease-in">
      <Navbar />
      <Flex flexDirection={"column"} flexGrow={1} p={8} overflowX="auto">{children}</Flex>
    </Flex>
  );
};

export default Layout;
